import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import Pagination from 'components/v2/PaginationV2';
import { showToast } from 'stores/ToastStore';
import { getFileIconClass } from 'helpers/helper_functions';
import { BARCODE } from 'config/documents';
import { useGetDocuments, useGetSignedUrls } from 'utils/DocumentsHooks';
const DOCUMENTS_PER_PAGE = 10;
const getAllForeignKeysForShipment = (shipment) => {
    var _a, _b;
    const invoiceIds = ((_a = shipment.receivables) === null || _a === void 0 ? void 0 : _a.map((receivable) => receivable.invoice_id)) || [];
    const payoutIds = ((_b = shipment.payables) === null || _b === void 0 ? void 0 : _b.map((payable) => payable.payout_id)) || [];
    return [shipment._id, ...invoiceIds, ...payoutIds].filter((key) => key);
};
export const ShipmentDocumentList = ({ shipments }) => {
    const [page, setPage] = useState(1);
    const { t } = useTranslation();
    const pageCount = Math.ceil(((shipmentDocumentsData === null || shipmentDocumentsData === void 0 ? void 0 : shipmentDocumentsData.count) || 0) / DOCUMENTS_PER_PAGE);
    const shipmentDocumentForeignKeys = [
        ...new Set(shipments
            .map((shipment) => getAllForeignKeysForShipment(shipment))
            .flat()
            .filter((key) => key)),
    ];
    const { data: shipmentDocumentsData, error: shipmentDocumentsError, loading, } = useGetDocuments({
        foreignKeys: shipmentDocumentForeignKeys,
        options: {
            limit: DOCUMENTS_PER_PAGE,
            skip: (page - 1) * DOCUMENTS_PER_PAGE,
            order: [{ field: 'createdAt', direction: 'desc' }],
        },
    });
    const { data: signedUrlsData, error: signedUrlsError } = useGetSignedUrls({
        foreignKeys: shipmentDocumentForeignKeys,
    });
    const openSignedUrl = (document) => async (event) => {
        event.preventDefault();
        const signedUrlData = signedUrlsData === null || signedUrlsData === void 0 ? void 0 : signedUrlsData.signedUrls.find((data) => data.id === document.id);
        window.open(signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.signedUrl, 'new');
    };
    useEffect(() => {
        if (shipmentDocumentsError) {
            showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', { error: shipmentDocumentsError }), 'error');
        }
    }, [shipmentDocumentsError]);
    useEffect(() => {
        if (signedUrlsError) {
            showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                error: signedUrlsError,
            }), 'error');
        }
    }, [signedUrlsError]);
    const renderShipmentDocuments = (shipment) => {
        const foreignKeys = getAllForeignKeysForShipment(shipment);
        return shipmentDocumentsData === null || shipmentDocumentsData === void 0 ? void 0 : shipmentDocumentsData.documents.filter((document) => [document.foreignKeys, foreignKeys].reduce((a, b) => a.filter((c) => b.includes(c))).length).filter((document) => document.type !== BARCODE.value).map((document) => (React.createElement("tr", { key: `shipment-document-${document.key}` },
            React.createElement("td", null,
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement("i", { className: getFileIconClass(document.key.split('.').pop().toUpperCase()) }),
                    React.createElement("a", { href: "#", title: document.name, onClick: openSignedUrl(document) }, document.name))),
            React.createElement("td", null,
                React.createElement("a", { href: `/shipments/${shipment._id}`, target: "blank" }, shipment.shipment_id)))));
    };
    if (!shipments.length) {
        return React.createElement("i", null, t('NO_SHIPMENT_ATTACHED_TO_ORDER'));
    }
    return (React.createElement(React.Fragment, null,
        loading ? (React.createElement(LoadingCircle, { text: t('LOADING') })) : (React.createElement("table", { className: "default-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, t('DOCUMENT', { count: 1 })),
                    React.createElement("th", null, t('SHIPMENT', { count: 1 })))),
            React.createElement("tbody", null, shipments.map((shipment) => renderShipmentDocuments(shipment))))),
        React.createElement(Pagination, { className: "border-t-0", perPage: DOCUMENTS_PER_PAGE, page: page, pages: pageCount, total: shipmentDocumentsData === null || shipmentDocumentsData === void 0 ? void 0 : shipmentDocumentsData.count, showCount: true, onPageClick: (page) => setPage(page), pageNeighbours: 0 })));
};
